var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 965 964",
    width: 965,
    height: 964,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "x-icon-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f3cc2f } \n\t\t.s1 { fill: #0f2c22 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m482.8 963.2c-266.1 0-481.3-215.2-481.3-481.4 0-266.1 215.2-481.3 481.3-481.3 266.2 0 481.4 215.2 481.4 481.3 0 266.2-215.2 481.4-481.4 481.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m363.7 203l150.8 201.6 186.7-201.6h52.1l-215.5 232.8 243 324.9h-177.3l-163.8-219-202.7 219h-52.1l231.5-250.1-230.1-307.6zm259.1 519.3h81.4l-359.7-481h-81.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.dc62872ad56f90f849884b613ec59ec0.svg";
export { ForwardRef as ReactComponent };